export function isLocal(): boolean {
  const host = window.location.hostname;

  // Vite sets DEV for the dev server and false in a production build
  if (import.meta.env.DEV) return true;

  // fallback: explicit hostname checks
  if (host === 'localhost' || host === '127.0.0.1' || host === '::1') return true;
  if (host.endsWith('.local')) return true;

  return false;
}